import axios from 'axios'

export const state = {
  subscriptions: [
    {
      record_id: '',
      agrm_id: '',
      agrm_num: '',
      cur_id: '',
      sub_state: '',
      tar_id: '',
      tar_name: '',
      tar_symbol: '',
      time_from: '',
      time_to: '',
      uid: ''
    }
  ]
}

export const mutations = {
  FETCH_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions
  },
  ADD_SUBSCRIPTION(state, subscription) {
    state.subscriptions.push(subscription)
  },
  STOP_SUBSCRIPTION(state, id) {
    state.subscriptions[id].sub_state = 3
  }
}

export const actions = {
  fetchSubscriptions({ commit }, agrmid) {
    return new Promise((resolve, reject) => {
      axios.get('subscriptions', {
        params: {
          agrmid: agrmid
        }
      })
        .then(promise => {
          commit('FETCH_SUBSCRIPTIONS', promise.data.results)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addSubscription({ commit }, subscription) {
    commit('ADD_SUBSCRIPTION', subscription)
  },
  stopSubscription({ commit }, id) {
    commit('STOP_SUBSCRIPTION', id)
  }
}

export default {
  state,
  mutations,
  actions
}
